<script setup>
import CompanyHeader from './CompaniesHeader/CompanyHeader.vue';
import PaginationFooter from 'dashboard/components-next/pagination/PaginationFooter.vue';

defineProps({
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, default: '' },
  currentPage: { type: Number, default: 1 },
  totalItems: { type: Number, default: 100 },
  activeSort: { type: String, default: 'name' },
  activeOrdering: { type: String, default: '' },
  showPaginationFooter: { type: Boolean, default: true },
});

const emit = defineEmits([
  'update:currentPage',
  'update:sort',
  'search',
  'create',
]);

const updateCurrentPage = page => {
  emit('update:currentPage', page);
};
</script>

<template>
  <section
    class="flex h-full w-full justify-evenly overflow-hidden bg-auth-canvas dark:bg-auth-canvas-dark"
  >
    <div class="flex flex-col w-full h-full transition-all duration-300">
      <CompanyHeader
        :search-value="searchValue"
        :header-title="headerTitle"
        :active-sort="activeSort"
        :active-ordering="activeOrdering"
        @search="emit('search', $event)"
        @update:sort="emit('update:sort', $event)"
        @create="emit('create')"
      />
      <main class="flex-1 overflow-y-auto px-3 sm:px-5 lg:px-6">
        <div class="mx-auto w-full max-w-6xl pb-6 pt-3 sm:pt-4">
          <slot name="default" />
        </div>
      </main>
      <footer
        v-if="showPaginationFooter"
        class="sticky bottom-0 z-10 border-t border-auth-border bg-auth-canvas/95 dark:border-auth-border-dark dark:bg-auth-canvas-dark/95"
      >
        <PaginationFooter
          current-page-info="COMPANIES_LAYOUT.PAGINATION_FOOTER.SHOWING"
          :current-page="currentPage"
          :total-items="totalItems"
          :items-per-page="25"
          class="mx-auto max-w-6xl !border-0 !bg-transparent"
          @update:current-page="updateCurrentPage"
        />
      </footer>
    </div>
  </section>
</template>
